import { Checkbox, Collapse, Flex } from '@approvalmax/ui/src/components';
import { compareHelpers } from '@approvalmax/utils';
import { asMutable } from 'modules/immutable';
import { memo } from 'react';

import { getColumnGroups } from '../../../../config/columnGroups';
import { ReportConfigColumn } from '../../../../types/ReportConfigColumn';
import { useSectionVisibleColumns } from './SectionVisibleColumns.hooks';
import { SectionVisibleColumnsProps } from './SectionVisibleColumns.types';

export const SectionVisibleColumns = memo<SectionVisibleColumnsProps>((props) => {
    const { reportConfig, onReportConfigChange } = props;

    const { company, expandedColumns, handleToggleColumnVisibility } = useSectionVisibleColumns(
        reportConfig,
        onReportConfigChange
    );

    const sections = getColumnGroups(company)
        .map((section) => {
            let columns = expandedColumns
                .filter(
                    (expandedColumn) =>
                        expandedColumn.columnDefinition.group === section.id &&
                        !expandedColumn.columnDefinition.isNotVisible
                )
                .map((expandedColumn) => expandedColumn.column);

            columns = asMutable(columns).sort(
                compareHelpers.comparatorFor<ReportConfigColumn>(compareHelpers.stringComparator2AscI, 'name')
            );

            if (columns.length === 0) {
                return null;
            }

            return (
                <Collapse
                    localStorageKey={`visible-columns-${section.id}`}
                    bordered
                    radius='small'
                    spacing='0 24 16 24'
                    name={section.text}
                    key={section.id}
                >
                    <Flex direction='column' spacing='12'>
                        {columns.map((column) => (
                            <Checkbox
                                checked={column.visible}
                                onChange={() => handleToggleColumnVisibility(column)}
                                key={column.id}
                            >
                                {column.name}
                            </Checkbox>
                        ))}
                    </Flex>
                </Collapse>
            );
        })
        .filter(Boolean);

    return <Flex direction='column'>{sections}</Flex>;
});

SectionVisibleColumns.displayName = 'SectionVisibleColumns';
